define('tdreviews', ['jquery'], function ($) {

    return {
        docBody: $('html, body'),
        reviewTabLink: $('[data-href="#kundenbewertung"]'),
        headlineStars: $('.product__details .product__headlines > .product__rating .rating.stars'),
        jumpToRating: function jumpToRating() {
            var _this = this;

            if (this.headlineStars.length === 0) return;

            this.headlineStars.on('click', function () {
                _this.reviewTabLink.trigger('click');
                _this.docBody.animate({ scrollTop: _this.reviewTabLink.parent().offset().top }, 1000);
            });
        },
        ratingHeight: function ratingHeight() {
            var wrapper = $('.reviewListBox');
            var reviews = wrapper.children('dl');
            var moreBtn = $('.review__more');
            var closeBtn = $('.review__close');
            var allHeights = 0;
            var maxHeight = wrapper.height();
            var firstElemetsHeight = 0;

            reviews.each(function (i, _) {
                var selfHeight = $(this).height();
                allHeights += selfHeight;
                if (i < 5) {
                    firstElemetsHeight += selfHeight;
                }
            });

            if (allHeights > wrapper.height()) {
                wrapper.css('max-height', firstElemetsHeight + 'px');
                moreBtn.find('span').html(reviews.length);
                moreBtn.show();

                moreBtn.on('click', function () {
                    wrapper.css('max-height', allHeights + reviews.length + 'px');
                    moreBtn.hide();
                    closeBtn.show();
                });

                closeBtn.on('click', function () {
                    wrapper.css('max-height', firstElemetsHeight + 'px');
                    moreBtn.show();
                    closeBtn.hide();
                });
            }
        },
        init: function init() {
            this.jumpToRating();
            this.ratingHeight();
        }
    };
});

